module.exports = __webpack_public_path__ + "img/boy-left.b18a1352.png";